/**
 * Opening quick replies: label = visible user message; quickKey = metadata.cvac_opening_quick for BE.
 */
export const CUSTOMER_VACATION_CHAT_OPENING_SECTION_TITLE =
  "הנה כמה יעדים פופולריים, או כתבו יעד אחר בשורת הטקסט למטה:";

export const CUSTOMER_VACATION_CHAT_OPENING_QUICK_REPLIES = [
  { label: "יוון", quickKey: "greece" },
  { label: "קפריסין", quickKey: "cyprus" },
  { label: "דובאי", quickKey: "dubai" },
  { label: "תאילנד", quickKey: "thailand" },
  /** BE: apply_opening_quick("destination_list") — 10 יעדים מובילים + כפתור "כל היעדים" (מלאי מלא) */
  { label: "יעדים פופולריים", quickKey: "destination_list" },
  /** BE: apply_opening_quick("all_destinations_opening") — חיפוש בכל המלאי (עוגן IATA + all_destinations) */
  { label: "כל היעדים", quickKey: "all_destinations_opening" },
];
